import { Avatar, IconButton } from "@maxhub/max-ui"
import { PlaceholderIcon } from "../shared/PlaceholderIcon"

const SmallIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
        <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
)

export const AvatarContainerExample = {
    title: 'Avatar.Container',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'form',
            label: 'form',
            type: 'enum',
            tsType: ['"circle"', '"squircle"'],
            default: 'circle',
            options: ['circle', 'squircle'],
        },
        {
            name: 'size',
            label: 'size',
            type: 'text',
            tsType: 'number',
            default: '64',
        },
        {
            name: 'overlay',
            label: 'overlay',
            type: 'boolean',
            tsType: 'ReactNode',
            default: false,
        },
        {
            name: 'onlineStatus',
            label: 'onlineStatus',
            type: 'boolean',
            tsType: 'boolean',
            default: false,
        },
        {
            name: 'innerClassNames',
            label: 'innerClassNames',
            type: 'static',
            tsType: 'InnerClassNamesProp<AvatarContainerElementKey>',
            value: '-',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
        {
            name: 'rightTopCorner',
            label: 'rightTopCorner',
            type: 'select',
            tsType: 'ReactNode',
            default: 'None',
            options: [
                { value: 'None', label: 'None' },
                { value: 'Avatar.CloseButton', label: 'Avatar.CloseButton' },
            ],
        },
        {
            name: 'rightBottomCorner',
            label: 'rightBottomCorner',
            type: 'select',
            tsType: 'ReactNode',
            default: 'IconButton',
            options: [
                { value: 'None', label: 'None' },
                { value: 'IconButton', label: 'IconButton' }
            ],
        },
    ],

    Preview({ props }){
        const overlayContent = props.overlay ? <Avatar.Overlay><PlaceholderIcon /></Avatar.Overlay> : undefined

        const rightTopCornerContent = props.rightTopCorner === 'Avatar.CloseButton'
            ? <Avatar.CloseButton aria-label="Закрыть" />
            : undefined

        const rightBottomCornerContent = props.rightBottomCorner === 'IconButton'
            ? <IconButton size="small" variant="secondary">
                <span style={{ display: 'flex', width: 16, height: 16, alignItems: "center", justifyContent: "center" }}><PlaceholderIcon /></span>
              </IconButton>
            : undefined

        const containerProps = {
            form: props.form,
            size: Number(props.size) || 64,
            onlineStatus: props.onlineStatus,
            ...(overlayContent ? { overlay: overlayContent } : {}),
            ...(rightTopCornerContent ? { rightTopCorner: rightTopCornerContent } : {}),
            ...(rightBottomCornerContent ? { rightBottomCorner: rightBottomCornerContent } : {}),
            ...(props.asChild ? { asChild: props.asChild } : {}),
        }

        return (
            <div style={{ display: 'flex', gap: 16, padding: 24 }}>
                <Avatar.Container {...containerProps}>
                    <Avatar.Icon>
                        <PlaceholderIcon />
                    </Avatar.Icon>
                </Avatar.Container>
                <Avatar.Container {...containerProps}>
                    <Avatar.Image
                        fallback="VT"
                        fallbackGradient="green"
                        style={{objectFit:"cover"}}
                        src="https://sun9-21.userapi.com/1N-rJz6-7hoTDW7MhpWe19e_R_TdGV6Wu5ZC0A/67o6-apnAks.jpg"
                    />
                </Avatar.Container>
                <Avatar.Container {...containerProps}>
                    <Avatar.Text gradient="red">
                        VT
                    </Avatar.Text>
                </Avatar.Container>
            </div>
        )
    },

    getCode(props){
        const overlayCode = props.overlay ? '\n    overlay={<Avatar.Overlay><PlaceholderIcon /></Avatar.Overlay>}' : ''
        const rightTopCornerCode = props.rightTopCorner === 'Avatar.CloseButton' ? '\n    rightTopCorner={<Avatar.CloseButton aria-label="Закрыть" />}' : ''
        const rightBottomCornerCode = props.rightBottomCorner === 'IconButton'
            ? '\n    rightBottomCorner={<IconButton size="small" variant="secondary"><PlaceholderIcon /></IconButton>}'
            : ''
        const onlineStatusCode = props.onlineStatus ? '\n    onlineStatus' : ''
        const asChildCode = props.asChild ? '\n    asChild' : ''

        const containerProps = `    form="${props.form}"\n    size={${props.size}}${onlineStatusCode}${overlayCode}${rightTopCornerCode}${rightBottomCornerCode}${asChildCode}`

        return `<>
  <Avatar.Container
${containerProps}
  >
    <Avatar.Icon>
      <PlaceholderIcon />
    </Avatar.Icon>
  </Avatar.Container>
  <Avatar.Container
${containerProps}
  >
    <Avatar.Image
      fallback="VT"
      fallbackGradient="green"
      src="https://sun9-21.userapi.com/1N-rJz6-7hoTDW7MhpWe19e_R_TdGV6Wu5ZC0A/67o6-apnAks.jpg"
    />
  </Avatar.Container>
  <Avatar.Container
${containerProps}
  >
    <Avatar.Text gradient="red">
      VT
    </Avatar.Text>
  </Avatar.Container>
</>`
    }

}